module.exports = __webpack_public_path__ + "img/care.2c615ca.png";